(function () {
    'use strict';

    angular
        .module('ib-bids-slider-module')
        .directive('rangeSliderOff', rangeSliderOff);

    rangeSliderOff.$inject = ['$timeout', '$window'];

    function rangeSliderOff ($timeout, $window) {
        return {
            restrict: 'A',
            link: link
        };

        function link (scope, elem) {
            scope.$on('sliderOff', (e, sliderOff) => {
                if (sliderOff) {
                    angular.element(elem).find('.ib-filter-custom--bids').addClass('ib-filter-custom--off');
                } else {
                    angular.element(elem).find('.ib-filter-custom--bids').removeClass('ib-filter-custom--off');
                }
            });
        }

    }
})();